import { render, staticRenderFns } from "./PracticeSharedList.vue?vue&type=template&id=78b82cd3&"
import script from "./PracticeSharedList.vue?vue&type=script&lang=js&"
export * from "./PracticeSharedList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "PracticeSharedList.vue"
export default component.exports